<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-customer-form
    [(formGroupRef)]="formGroupRef"
    [(value)]="value">
  </app-customer-form>
</app-base-entry-dialog-template>
